import React from "react";
import BarChartComponent from "./BarChartComponent";
import {
  numeroCursos,
  numeroMatriculas,
  numeroPessoasPorEtnias,
} from "./dados";

const Indicators = () => {
  const tableStyle = {
    border: "1px solid black",
    borderCollapse: "collapse",
  };

  return (
    <div>
      <section id="producoes" style={{ paddingTop: "100px" }}>
        <div class="row text-center justify-content-center">
          <h2 class="text-black mb-4">Indicadores</h2>
        </div>

        <div class="row mx-5">
          <div class="card mb-3">
            <div className="col-md-8">
              <p>Número de cursos ofertados no Brasil</p>

              <p>
                <table style={tableStyle}>
                  <tr>
                    <td>Ano</td>
                    <td>2017</td>
                    <td>2018</td>
                    <td>2019</td>
                    <td>2020</td>
                    <td>2021</td>
                  </tr>
                  <tr>
                    <td>Quantidade</td>
                    <td>11259</td>
                    <td>11473</td>
                    <td>10889</td>
                    <td>10878</td>
                    <td>11005</td>
                  </tr>
                </table>
              </p>

              <BarChartComponent data={numeroCursos} />
            </div>
          </div>
        </div>

        <div class="row mx-5">
          <div class="card mb-3">
            <div className="col-md-8">
              <p>Número de matrículas ofertadas no Brasil</p>
              <BarChartComponent data={numeroMatriculas} />
            </div>
          </div>
        </div>

        <div class="row mx-5">
          <div class="card mb-3">
            <div className="col-md-8">
              <p>Número de pessoas por etnia</p>
              <BarChartComponent
                data={numeroPessoasPorEtnias}
                columns={[
                  "Amarelo",
                  "Branco",
                  "Indígena",
                  "Parda",
                  "Preta",
                  "Não declarada",
                ]}
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Indicators;
